'use client';

import dynamic from 'next/dynamic';
import { useMemo } from 'react';

import { locations } from '@/slw/entities/contact-us';

// Dynamically import the Map component to avoid SSR issues with Leaflet
const MapComponent = dynamic(() => import('@/slw/shared/ui/map').then((mod) => mod.MapComponent), {
  ssr: false,
  loading: () => (
    <div className='w-full h-full flex items-center justify-center bg-muted'>
      <div className='text-center'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto'></div>
        <p className='mt-4 text-lg'>Loading map...</p>
      </div>
    </div>
  ),
});

export function InteractiveMap() {
  // Use the first location's position as map center, or fallback to Clovis, CA
  const mapConfig = useMemo(() => {
    const firstLocation = locations[0];
    return {
      center: firstLocation?.position || [36.8250, -119.7029] as [number, number],
      zoom: 15,
    };
  }, []);

  return (
    <div className='rounded-2xl shadow-lg h-[20rem] lg:h-[25rem] w-full overflow-hidden'>
      <MapComponent locations={locations} mapConfig={mapConfig} />
    </div>
  );
}
